import React from 'react';
import { IconsPros } from './types';

/**
 * Preview Icon component
 *
 * @returns JSX.ELEMENT
 */
export const PreviewIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M9.67,3.29a5,5,0,0,0-.94-.23h0L8.41,3,8,3H8l-.4,0a5,5,0,0,0-1.32.29C3.05,4.4,0,8,0,8a21.53,21.53,0,0,0,5.52,4.34A5,5,0,0,0,7.63,13L8,13H8l.37,0a5,5,0,0,0,2.07-.62A21.47,21.47,0,0,0,16,8S12.91,4.36,9.67,3.29ZM8,11a3,3,0,1,1,3-3A3,3,0,0,1,8,11Z" />
      <circle cx="8" cy="8" r="1.5" />
    </svg>
  );
};
